import { NewCostCentersEnabledDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export const useCostCentersFeatureEnabled = () => {
  const { company } = useCurrentSession()
  const { data } = useQuery(NewCostCentersEnabledDocument, {
    variables: { companyId: company.id },
  })

  return !!data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'dev_cost_centers_v2'
  )?.enabled
}
